<script>
import WizardForm from "@/view/components/lpm/WizardForm.vue";
export default {
  name: "local-performance-marketing-modal",
  components: {
    WizardForm
  },
  async mounted() {
    console.log("Local Performance Marketing Modal");
    this.$store.commit("setLpmLocations", []);
  },
  methods: {
    close() {
      this.$refs["local-performance-marketing-modal"].hide();
    }
  }
};
</script>

<template>
  <b-modal
    id="local-performance-marketing-modal"
    ref="local-performance-marketing-modal"
    title="Local Performance Marketing (LPM)"
    no-close-on-esc
    no-close-on-backdrop
    centered
    hide-footer
    size="xl"
  >
    <div class="p-5">
      <p>
        Only pay when we prove a customer who engaged with the campaign spent
        money at your business. We take a flat 16.75% for every successful
        transaction, representing a 6x ROI though these guests often have larger
        check averages, yield ROIs over 10x. We target lapsed customers and
        prospective customers who spend a lot in your industry that live around
        you.
      </p>
    </div>
    <wizard-form @input="close"></wizard-form>
  </b-modal>
</template>
